import { render } from "./AppCreateFotozoneModal.vue?vue&type=template&id=70f10f6c&scoped=true"
import script from "./AppCreateFotozoneModal.vue?vue&type=script&lang=js"
export * from "./AppCreateFotozoneModal.vue?vue&type=script&lang=js"

import "./AppCreateFotozoneModal.vue?vue&type=style&index=0&id=70f10f6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f10f6c"]])

export default __exports__